// Шкала и форматирование среднего возраста работ. Вынесено из RatingSidebar, потому что то же
// форматирование понадобилось в строке таблицы (RatingItem).

// Шаг ползунка — полгода, потолок — 5 лет. Верхнее деление читается как «5y+» («и старше»).
export const AGE_STEP_MONTHS = 6;
export const AGE_MAX_MONTHS = 60;

const MS_IN_MONTH = 30.44 * 24 * 60 * 60 * 1000;   // средняя длина месяца, для оценки возраста

export const formatAge = (months) => {
  const value = Number(months) || 0;
  if (!value) return '0';

  const years = Math.floor(value / 12);
  const rest = value % 12;

  return [years && `${years}y`, rest && `${rest}m`].filter(Boolean).join(' ');
};

// avgCreationDate хранится как ms (тот же тип, что AdobeRank.creationDate). null означает
// «возраст неизвестен» — у записей, сохранённых до появления поля.
export const ageInMonths = (creationDateMs) => {
  const timestamp = Number(creationDateMs);
  if (!timestamp) return null;

  return Math.max(0, Math.round((Date.now() - timestamp) / MS_IN_MONTH));
};
